import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import { type JSX, useMemo } from "react";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { CustomWebsiteCard } from "@/components/site/website/custom-website-card";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ManageWebsiteAbout } from "@/components/site/manage-website-about";
import { ManageWebsiteCover } from "@/components/site/manage-website-cover";
import { ManageWebsiteDisplayInfo } from "@/components/site/manage-website-display-info";
import { ManageWebsitePhoto } from "@/components/site/manage-website-photo";
import { ManageWebsiteTheme } from "@/components/site/manage-website-theme";
import { useGraphQL } from "@/hooks/use-graphql";

const ProfessionalSiteQuery = graphql(/* GraphQL */ `
  query ProfessionalSiteQuery($codUsuario: Int!) {
    ...CustomWebsiteCardFragment
    ...ManageWebsiteCoverFragment
    ...ManageWebsitePhotoFragment
    ...ManageWebsiteDisplayInfoFragment
    ...ManageWebsiteThemeFragment
  }
`);

const ProfessionalSitePage = (): JSX.Element => {
  const { user, flags } = useRouteContext({ from: "__root__" });
  const queryResult = useGraphQL(ProfessionalSiteQuery, { codUsuario: user.codUsuario });
  const { data } = queryResult;

  const shouldShowNewOptions = useMemo(() => {
    return flags["deve-mostrar-novas-alteracoes-do-site"];
  }, [flags]);

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Meu site profissional" />
      </HeaderRoot>
      <Page className="p-6 space-y-6">
        {data ? (
          <>
            <CustomWebsiteCard data={data} callDomain />
            {shouldShowNewOptions ? (
              <>
                <ManageWebsiteCover data={data} />
                <ManageWebsitePhoto data={data} />
                <ManageWebsiteTheme data={data} />
                <ManageWebsiteAbout />
                <ManageWebsiteDisplayInfo data={data} />
              </>
            ) : null}
          </>
        ) : null}
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/professional-site/")({
  component: ProfessionalSitePage,
});
